export const infoService = () => {
  const $infoHolders = document.querySelectorAll<HTMLSpanElement>('.options-table__sign-holder')

  if ($infoHolders) {
    $infoHolders.forEach((holder) => {
      holder.addEventListener('mouseover', () => {
        const info = holder.querySelector<HTMLSpanElement>('.options-table__answer-info')
        if (info) info.hidden = false
      })
    })

    $infoHolders.forEach((holder) => {
      holder.addEventListener('mouseleave', () => {
        const info = holder.querySelector<HTMLSpanElement>('.options-table__answer-info')
        if (info) info.hidden = true
      })
    })
  }
}
